import { render, staticRenderFns } from "./AgencyIndex.vue?vue&type=template&id=a5006ca8&"
import script from "./AgencyIndex.vue?vue&type=script&lang=js&"
export * from "./AgencyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports